import React from 'react';
import {
  Pagination as MantinePagination,
  PdsMantineText,
  PdsBox,
  NativeSelect,
} from '@podium-design-system/react-components';

const PAGE_SIZE_OPTIONS = [
  { value: '10',  label: '10 / page' },
  { value: '20',  label: '20 / page' },
  { value: '50',  label: '50 / page' },
  { value: '100', label: '100 / page' },
];

/** Shared Mantine class names — styled in argus-typography.css (active page highlight). */
export const PAGINATION_CLASS_NAMES = {
  root: 'argus-pagination-root',
  control: 'argus-pagination-control',
  dots: 'argus-pagination-dots',
};

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage = 20,
  totalPages: totalPagesOverride,
  onPageChange,
  onPageSizeChange,
  showPageInfo = true,
  /** When true, centers page controls (e.g. dashboard lists without row counts). */
  centered = false,
}) => {
  const totalPages = totalPagesOverride ?? Math.ceil(totalItems / itemsPerPage);

  if (totalPagesOverride == null && totalItems === 0) return null;
  if (totalPages <= 1) return null;

  const hasItemCounts = totalPagesOverride == null && totalItems > 0 && itemsPerPage > 0;
  const startItem = hasItemCounts ? (currentPage - 1) * itemsPerPage + 1 : null;
  const endItem = hasItemCounts ? Math.min(currentPage * itemsPerPage, totalItems) : null;
  const showMeta = showPageInfo && hasItemCounts;

  return (
    <PdsBox
      direction="row"
      alignItems="center"
      justifyContent={centered || !showMeta ? 'center' : 'space-between'}
      wrap="wrap"
      gap="sm"
      className="argus-pagination"
      style={{ marginTop: 12, paddingTop: 8, paddingBottom: 8, width: centered ? '100%' : undefined }}
    >
      {!centered && (showMeta || onPageSizeChange) && (
        <PdsBox direction="row" alignItems="center" gap="sm">
          {showMeta && (
            <PdsMantineText type="textline" color="neutral" className="argus-type-meta">
              Showing {startItem}–{endItem} of {totalItems}
            </PdsMantineText>
          )}
          {onPageSizeChange && (
            <NativeSelect
              value={String(itemsPerPage)}
              classNames={{ input: 'argus-native-select-input' }}
              onChange={(e) => {
                onPageSizeChange(Number(e.target.value));
              }}
              data={PAGE_SIZE_OPTIONS}
              size="xs"
              style={{ minWidth: 110 }}
            />
          )}
        </PdsBox>
      )}
      <MantinePagination
        total={totalPages}
        value={currentPage}
        onChange={onPageChange}
        withEdges
        siblings={1}
        size="sm"
        classNames={PAGINATION_CLASS_NAMES}
      />
    </PdsBox>
  );
};

export default Pagination;
